import { appLanguage } from "@shared/i18n";

export type TGameEventData =
  | { event: "play_start" }
  | { event: "play_end" }
  | { event: "balance_updated"; coins: number };

export const enum GameEvents {
  SPIN_START = "play_start",
  SPIN_END = "play_end",
  BALANCE_UPDATED = "balance_updated",
}
export type TExternalCallback = () => void;
export type TLocale = keyof typeof appLanguage;
export interface ILanguages {
  defaultLang: TLocale;
  languages: Array<{ code: TLocale; name: string }>;
}
